import { useState, useEffect, useContext, useRef } from "react";
import { useForm } from "react-hook-form";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";

import { api_without_cancellation } from "@/api/api";

import AutoCompleteSearch from "../../Insurance/AutoCompleteSearch";
import { ClientDataContext } from "../shared/DataContext";
import { getClientId, getCaseId } from "../../../Utils/helper";
import SelectStateModal from "../../TreatmentPage/modals/state-modal/SelectStateModal";

// import AutoCompleteSearch from './AutoCompleteSearch';

const InsuranceModal = ({ handleClose, show }) => {
  const origin = process.env.REACT_APP_BACKEND_URL;
  const currentCase = getCaseId();
  const client = getClientId();
  // const token = getAuthorizationToken();
  // const accessToken = getToken();
  const [loading, setLoading] = useState(false);

  const [statesAbrs, setStatesAbrs] = useState([]);
  const [stateShow, setStateShow] = useState(false);

  const [selectedState, setSelectedState] = useState("");
  const [insuranceTypes, setInsuranceTypes] = useState([]);
  const [selectedCompanyId, setSelectedComponyId] = useState("");
  const handleStateShow = () => setStateShow(!stateShow);

  const [searchedCompany, setSearchedCompany] = useState([]);
  const [searchedAdjuster, setSearchedAdjuster] = useState([]);
  const searchType = useRef("");
  const {
    register,
    setValue,
    reset,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const { isClientDataUpdated, setIsClientDataUpdated } = useContext(ClientDataContext);

  const fetchSatesData = async () => {
    try {
      const response = await api_without_cancellation.get("/api/states/");
      if (response.status === 200) {
        setStatesAbrs(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  //   Formting phone number an fax number
  const formatNumber = (inputVal) => {
    inputVal = inputVal.replace(/\D/g, "");
    // Insert formatting characters
    inputVal =
      "(" +
      inputVal.substring(0, 3) +
      ") " +
      inputVal.substring(3, 6) +
      "-" +
      inputVal.substring(6, 10);
    // Update input value
    return inputVal;
  };

  const selectedInsuranceTypeId = parseInt(watch("insurance_type_id"));

  // Handling Searching
  const handleSearch = async (event, type) => {
    searchType.current = type;
    let companies = [];
    let adjusters = [];

    if (event.target.value.length >= 2) {
      if (type === "company") {
        const response = await api_without_cancellation.get("/api/insurances/search/");
        companies = response.data.data.filter(
          (insurance) =>
            // Check if the insurance type matches the selected insurance type
            parseInt(insurance.insurance_type) === selectedInsuranceTypeId &&
            (insurance?.company_name?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
              insurance?.adjuster_firstname
                ?.toLowerCase()
                .startsWith(event.target.value.toLowerCase()) ||
              insurance?.adjuster_lastname
                ?.toLowerCase()
                .startsWith(event.target.value.toLowerCase()) ||
              insurance?.address1?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
              insurance?.address2?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
              insurance?.city?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
              insurance?.state?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
              insurance?.zip?.toLowerCase().startsWith(event.target.value.toLowerCase()))
        );
      } else if (type === "adjuster") {
        const response = await api_without_cancellation.get(
          "/api/general/search_filter_adjuster_directoires/",
          {
            params: {
              company_id: selectedCompanyId ? selectedCompanyId : "",
            },
          }
        );

        adjusters = response.data.data.filter(
          (insurance) =>
            insurance?.company_name.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
            insurance?.adjuster_firstname
              ?.toLowerCase()
              .startsWith(event.target.value.toLowerCase()) ||
            insurance?.adjuster_lastname
              ?.toLowerCase()
              .startsWith(event.target.value.toLowerCase()) ||
            insurance?.address1?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
            insurance?.address2?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
            insurance?.city?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
            insurance?.state?.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
            insurance?.zip?.toLowerCase().startsWith(event.target.value.toLowerCase())
        );
      }
    }

    setSearchedCompany(companies);
    setSearchedAdjuster(adjusters);
  };

  const fetchCaseTypesData = async () => {
    try {
      const response = await api_without_cancellation.get("/api/general/insurance_types/");
      if (response.status === 200) {
        setInsuranceTypes(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchSatesData();
    fetchCaseTypesData();
  }, [origin]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await api_without_cancellation.post(
        `/api/client-page/add_insurance/${client}/${currentCase}/`,
        { ...data, client_insurance: true }
      );
    } catch (error) {
      console.error(error);
    }
    setIsClientDataUpdated(!isClientDataUpdated);
    setLoading(false);
    reset();
    handleClose();
  };

  const handleStateChange = (state) => {
    setValue("state", state.StateAbr);
    setSelectedState(state.StateAbr);
  };

  const handleSelectedInsurance = (id) => {
    if (searchType.current === "company") {
      let selectedCompany = searchedCompany.filter((insurance) => insurance.id === id);
      selectedCompany = { ...selectedCompany[0] };
      setValue("phone_number", formatNumber(selectedCompany?.phone));
      setValue("fax", formatNumber(selectedCompany?.fax));
      setValue("email", selectedCompany?.email);
      setValue("company_name", selectedCompany?.company_name);
      setValue("website", selectedCompany?.website);
      setValue("address_1", selectedCompany?.address1);
      setValue("address_2", selectedCompany?.address2);
      setValue("zip", selectedCompany?.zip);
      setValue("city", selectedCompany?.city);
      setValue("extension", selectedCompany?.extension);
      setSelectedComponyId(selectedCompany?.company_id);

      const stateObj = statesAbrs.find((state) => state.StateAbr === selectedCompany?.state);
      if (stateObj) {
        setValue("state", stateObj.StateAbr);
      } else {
        console.warn("State abbreviation not found in statesAbrs");
      }
      setSelectedState(selectedCompany?.state || "");

      setSearchedCompany([]);
    }

    if (searchType.current === "adjuster") {
      let selectedAdjuster = searchedAdjuster.filter((insurance) => insurance.id === id);
      selectedAdjuster = { ...selectedAdjuster[0] };
      setValue("adjuster_fname", selectedAdjuster?.adjuster_firstname);
      setValue("adjuster_lname", selectedAdjuster?.adjuster_lastname);

      setSearchedAdjuster([]);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="modal-800p"
        style={{
          opacity: stateShow ? "0.5" : "1",
        }}
      >
        <Modal.Header className="modal-header text-center bg-primary-fixed height-25 p-0 d-flex align-items-center">
          <Modal.Title className="mx-auto font-weight-600">
            <h4 className="text-uppercase popup-heading-color">Add Client Insurance Coverage</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="panel-popups-body mx-1">
          <Form id="addinsurance_form" onSubmit={handleSubmit(onSubmit)}>
            <Row className="p-b-5">
              <Col className="p-0" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Enter Policy #"
                  {...register("policy_number")}
                  className="height-25"
                />
              </Col>
              <Col className="ps-4 pe-4" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Enter Claim #"
                  {...register("claim_number")}
                  className="height-25"
                />
              </Col>
              <Col className="p-0" md={4}>
                <Form.Select
                  {...register("insurance_type_id")}
                  required
                  className={`height-25 py-0 form-control ${errors.state && "is-invalid"}`}
                >
                  {" "}
                  <option key="" value="">
                    Select Coverage Type
                  </option>
                  {insuranceTypes?.map((insuranceType) => (
                    <option key={insuranceType.id} value={insuranceType.id}>
                      {insuranceType.name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
            <Row className="p-b-5">
              <Col className="p-0" md={12}>
                <Form.Control
                  type="text"
                  placeholder="Type Insurance Company Name to add from library"
                  onKeyUp={() => handleSearch(event, "company")}
                  disabled={!selectedInsuranceTypeId}
                  className="height-25"
                />
                {searchedCompany.length > 0 && (
                  <AutoCompleteSearch
                    searchedInsurances={searchedCompany}
                    selectedInsurance={handleSelectedInsurance}
                    isCompany={true}
                  />
                )}
              </Col>
            </Row>
            <Row className="p-b-5">
              <Col className="p-0" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Company name"
                  {...register("company_name")}
                  className="height-25"
                />
              </Col>
              <Col className="ps-4 pe-4" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Website"
                  {...register("website")}
                  className="height-25"
                />
              </Col>
              <Col className="p-0" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Phone"
                  {...register("phone_number")}
                  className="height-25"
                />
              </Col>
            </Row>
            <Row className="p-b-5">
              <Col className="p-0" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Fax"
                  {...register("fax")}
                  className="height-25"
                />
              </Col>
              <Col className=" ps-4 pe-4" md={4}>
                <Form.Control
                  type="email"
                  onKeyUp={() => {}}
                  placeholder="Email"
                  {...register("email")}
                  className="height-25"
                />
              </Col>
              <Col className="p-0" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Extension"
                  {...register("extension")}
                  className="height-25"
                />
              </Col>
            </Row>

            <Row className="p-b-5">
              <Col className="p-0" md={6}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Address 1"
                  {...register("address_1")}
                  className="height-25"
                />
              </Col>

              <Col className="ps-4 pe-0" md={6}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Address 2"
                  {...register("address_2")}
                  className="height-25"
                />
              </Col>
            </Row>
            <Row className="p-b-5">
              <Col className="p-0" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="City"
                  {...register("city")}
                  className="height-25"
                />
              </Col>
              <Col className=" ps-4 pe-4" md={4}>
                <div className="position-relative height-25 custom-select-new-provider">
                  <div
                    className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                    onClick={handleStateShow}
                  >
                    <span>
                      {selectedState ? (
                        <div className="d-flex align-items-center">
                          <svg
                            style={{
                              width: "15px",
                              height: "15px",
                              fill: "var(--primary-80)",
                              color: "var(--primary-80)",
                              stroke: "var(--primary-80)",
                            }}
                            className={`icon icon-state-${selectedState}`}
                          >
                            <use xlinkHref={`#icon-state-${selectedState}`} />
                          </svg>
                          {selectedState}
                        </div>
                      ) : (
                        "Select State"
                      )}
                    </span>
                  </div>
                </div>
              </Col>
              <Col className="p-0" md={4}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Zip"
                  {...register("zip")}
                  className="height-25"
                />
              </Col>
            </Row>

            <Row className="p-b-5">
              <Col className="p-b-5 p-0" md={12}>
                <Form.Control
                  type="text"
                  placeholder="Type Adjuster Name to add from library"
                  onKeyUp={() => handleSearch(event, "adjuster")}
                  disabled={!selectedCompanyId}
                  className="height-25"
                />
                {searchedAdjuster.length > 0 && (
                  <AutoCompleteSearch
                    searchedInsurances={searchedAdjuster}
                    selectedInsurance={handleSelectedInsurance}
                    isAdjuster={true}
                  />
                )}
              </Col>
            </Row>
            <Row className="p-b-5">
              <Col className="p-0" md={6}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Adjuster First Name"
                  {...register("adjuster_fname")}
                  className="height-25"
                />
              </Col>

              <Col className="ps-4 pe-0" md={6}>
                <Form.Control
                  type="text"
                  onKeyUp={() => {}}
                  placeholder="Adjuster Last Name"
                  {...register("adjuster_lname")}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <div className="d-flex justify-content-between align-items-center p-l-5 p-b-5 p-r-5">
          <Button
            variant="secondary"
            className="height-25"
            style={{ padding: "0px 12px" }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            form="addinsurance_form"
            variant="success"
            type="submit"
            className="m-l-5 bg-success height-25"
            style={{ padding: "0px 12px" }}
          >
            {loading ? "Saving..." : "Save & Close"}
          </Button>
        </div>
      </Modal>
      {stateShow && (
        <SelectStateModal
          show={stateShow}
          handleClose={handleStateShow}
          onChange={handleStateChange}
          statesData={statesAbrs}
        />
      )}
    </>
  );
};

export default InsuranceModal;
